import { BaseModel } from "../base.model";

/**
 * A Lookup model from the dao. Translated from:
 * https://github.com/AMPSystems/dao/blob/develop/src/main/java/us/ampre/dao/lookup/Lookup.java
 * and
 * https://github.com/AMPSystems/dao/blob/develop/src/main/java/us/ampre/dao/customer/CustomerLookup.java
 * and combined into one for my convenience.
 */
export class LookupModel extends BaseModel {

  public id: number = null;
  public customerName: string = null;
  public lookupKey: string = null;
  public lookupName: string = null;
  public lookupValue: string = null;
  public lookupDisplayName: string = null;
  public ordinal: number = 0;
  public definition: string = null;
  public constraints: LookupConstraint[][] = [];
  public createDate: string = null;
  public modifyDate: string = null;
  //these are not really necessary
  public resoDefined: boolean = false;
  public lookupDisplayNameSynonyms: string = null;
  public references: string = null;
  public elementStatus: string = 'Active';
  public lookupStatus: string = 'Active';
  public statusDate: string = null;
  public replacedByLookupKey: string = null;

  constructor(model?: Partial<LookupModel>) {
    super();
    this.overwrite(model);
  }
}

export interface LookupConstraint {
    standardName: string,
    allowed?: string[],
    disallowed?: string[]
}